
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 19.96 15\" id=\"photographs\" ><defs/><title>photographs</title><g id=\"photographs_Layer_2\" data-name=\"Layer 2\"><g id=\"photographs_Icons\"><g id=\"photographs_photographs\"><path class=\"cls-1\" d=\"M0 4h16v11H0z\"/><path class=\"cls-1\" d=\"M19.96 10.5H17.5v-8h-13V0h15.46v10.5z\"/></g></g></g></symbol>";
module.exports = sprite.add(image, "photographs");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/photographs.svg
// module id = 662
// module chunks = 1474